


































































































































































































import multiselectMixin from './multiselectMixin'
import pointerMixin from './pointerMixin'
import Teleport from '@/components/Teleport.vue'

export default {
  name: 'VueMultiselect',
  components: { Teleport },
  mixins: [multiselectMixin, pointerMixin],
  props: {
    name: {
      type: String,
      default: '',
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select',
    },
    selectGroupLabel: {
      type: String,
      default: 'Press enter to select group',
    },
    selectedLabel: {
      type: String,
      default: 'Selected',
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove',
    },
    deselectGroupLabel: {
      type: String,
      default: 'Press enter to deselect group',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 99999,
    },
    maxHeight: {
      type: Number,
      default: 188,
    },
    limitText: {
      type: Function,
      default: (count) => `and ${count} more`,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openDirection: {
      type: String,
      default: '',
    },
    showNoOptions: {
      type: Boolean,
      default: true,
    },
    showNoResults: {
      type: Boolean,
      default: true,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    styleType: {
      type: String,
      default: 'office_old',
    },
    isNewStyle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSingleLabelVisible() {
      return (
        (this.singleValue || this.singleValue === 0) &&
        (!this.isOpen || !this.searchable) &&
        !this.visibleValues.length
      )
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen)
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : []
    },
    singleValue() {
      return this.internalValue[0]
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : ''
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : ''
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : ''
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : ''
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : ''
    },
    inputStyle() {
      if (
        this.searchable ||
        (this.multiple && this.value && this.value.length)
      ) {
        return this.isOpen
          ? { width: '100%' }
          : { width: '0', position: 'absolute', padding: '0' }
      }
      return {}
    },
    contentStyle() {
      return this.options.length
        ? { display: 'inline-block' }
        : { display: 'block' }
    },
    isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true
      } else if (
        this.openDirection === 'below' ||
        this.openDirection === 'bottom'
      ) {
        return false
      } else {
        return this.preferredOpenDirection === 'above'
      }
    },
  },
  mounted() {
    if (process.browser && !this.observer) {
      this.onResize()
      screen.orientation.addEventListener('change', this.getListPosition)
      this.observer.observe(document.body)
    }
  },
  beforeDestroy() {
    if (this.observer && process.browser) {
      screen.orientation.removeEventListener('change', this.getListPosition)
      this.observer.unobserve(document.body)
      this.observer.disconnect()
    }
  },
}
